import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Scores } from './Scores';
import { Elements } from './Elements';
import { useRosaContext } from '../../context';
import { Paragraph, Title } from '@/components/Typography';
import { useGetRosaScores } from '../../hooks/useGetRosaScores';

export function Evaluation() {
	const { organization_id, company_id, report_id } = useRosaContext();

	const { data } = useGetRosaScores({
		organization_id,
		company_id,
		report_id
	});

	return (
		<Row gutter={[0, 50]}>
			<Col span={24}>
				<Row align="middle">
					<Col xs={12}>
						<Title level={4}>{I18n.get('Evaluation')}</Title>
					</Col>
					<Col xs={24}>
						<Paragraph style={{ fontSize: 16, margin: 0 }}>
							{I18n.get('Pre-set specific characteristics')}
						</Paragraph>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Scores scores={data} />
			</Col>
			<Col span={24}>
				<Elements />
			</Col>
		</Row>
	);
}
